import React from "react";
import './App.css';
import { Provider as StyletronProvider, DebugEngine } from "styletron-react";
import { Client as Styletron } from "styletron-engine-atomic";
import ConnectProvider from './context/connectContext';
import HomePage from './pages/HomePage';
import PartnerPage from './pages/PartnerPage';
import Navbar from './components/NavBar/NavBar';
import Footer from './components/Footer/Footer'
import { HashRouter as Router, Route, Routes } from 'react-router-dom'
import 'chartjs-adapter-date-fns';

const debug = process.env.NODE_ENV === "production" ? void 0 : new DebugEngine();
const engine = new Styletron();

const App = () => {
  return (
    <ConnectProvider>
      <StyletronProvider
        value={engine}
        debug={debug}
        debugAfterHydration
      >
        <Router>
              <Navbar/>
                <Routes>
                  <Route
                    path='/'
                    element={<HomePage/>}
                  />
                  <Route
                    exact path='/partner/:name'
                    element={<PartnerPage/>}
                  />
                </Routes>
                <Footer/>
        </Router>
      </StyletronProvider>
    </ConnectProvider>
  );
}

export default App;